import { Box } from '@mui/material';
import React from 'react';
import { MultipleChoiceToggle } from '../MultipleChoiceToggle';
const Bandwidth = [
    {
        value: 'noBandwidth',
        label: 'No Bandwidth',
        description: 'We do not have the bandwidth to take on new funding efforts, but do need the funds.',
    },
    {
        value: 'someBandwidth',
        label: 'Some Bandwidth',
        description: 'There is some bandwidth, but we do not have dedicated personnel for grants.',
    },
    {
        value: 'dedicatedBandwidth',
        label: 'Dedicated Bandwidth',
        description: 'We have dedicated personnel and would like a steady stream of grant opportunities.',
    },
];
export const BandwidthField = ({ currentValue, handleFormValues }) => {
    return (React.createElement(Box, { mb: 3 },
        React.createElement(MultipleChoiceToggle, { name: "bandwidth", options: Bandwidth, selectedOption: currentValue, handleFormValues: handleFormValues, question: "What is your bandwidth for pursuing opportunities?" })));
};
